import { UseCaseKey } from '@pages/driverAnalysis/driverAnalysisReducer';
import { UseCaseConfig } from '@pages/driverAnalysis/useCaseConfig';
import { trackingAttributes } from '@utils/tracking';
import cn from 'classnames';
import { camelCase, upperFirst } from 'lodash';
import React from 'react';
import { FormattedMessage } from 'react-intl';

interface UseCasesI {
    onSelect: (key: UseCaseKey) => void;
    active: string;
    useCaseConfig: UseCaseConfig[];
    location?: string;
}

const fleetViews: Record<string, string> = {
    overview: 'overview',
    consumption: 'consumption',
    'operating-condition': 'operatingStatus',
};

const UseCases: React.FC<UseCasesI> = ({ onSelect, active, useCaseConfig = [], location = '' }) => (
    <>
        <span className="text-medium padding-bottom-5 text-size-12">
            <FormattedMessage id="select.view" />
        </span>

        <div className="btn-toolbar">
            <div className="btn-group display-flex flex-row">
                {useCaseConfig.map(({ key }) => {
                    const fleetView = location === 'fleetAnalysis' ? fleetViews[key] : undefined;

                    return (
                        <button
                            key={key}
                            className={cn(
                                'btn btn-default ToggleButton',
                                active === key ? 'active' : '',
                            )}
                            onClick={(): void => onSelect(key as UseCaseKey)}
                            data-test={'useCaseButton' + key}
                            data-track-ga-event-trigger={fleetView ? 'click' : undefined}
                            data-track-ga-event-name={
                                fleetView ? 'perform_fleet_view_clicked' : undefined
                            }
                            data-track-ga-event-element-name={fleetView}
                        >
                            <div
                                {...trackingAttributes(
                                    'click',
                                    'perform, chartSelect',
                                    `selectChart${upperFirst(location)}`,
                                    `dataSelect, ${location}, ${camelCase(key)}`,
                                )}
                            >
                                <FormattedMessage id={`view-data.${key}`} />
                            </div>
                        </button>
                    );
                })}
            </div>
        </div>
    </>
);

export default UseCases;
